import { SubjectStatus } from './subject-status';
export var AgentLastStatusEnum;
(function (AgentLastStatusEnum) {
    AgentLastStatusEnum[AgentLastStatusEnum["checkIn"] = 0] = "checkIn";
    AgentLastStatusEnum[AgentLastStatusEnum["checkInRegisteringInformation"] = 1] = "checkInRegisteringInformation";
    AgentLastStatusEnum[AgentLastStatusEnum["checkInTransactionCompleted"] = 2] = "checkInTransactionCompleted";
    AgentLastStatusEnum[AgentLastStatusEnum["checkOut"] = 3] = "checkOut";
    AgentLastStatusEnum[AgentLastStatusEnum["checkOutRegisteringInformation"] = 4] = "checkOutRegisteringInformation";
})(AgentLastStatusEnum || (AgentLastStatusEnum = {}));
export class AgentStatus extends SubjectStatus {
}
//# sourceMappingURL=agent-status.js.map